import {Parameter, UrlConverterPage} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import OrientationEnum from "./OrientationEnum";
import LengthUnit from "../units/LengthUnit";

export class PortalUrlConverterPage extends UrlConverterPage implements Parameter {
	public format?: string;
	public orientation?: OrientationEnum;
	public unit?: LengthUnit;

	constructor(data: any) {
		super(data);

		this.format = FunctionHelper.exists(data?.format) ? data.format : "A4";
		this.orientation = FunctionHelper.exists(data?.orientation) ? data.orientation : OrientationEnum.VERTICAL;
		this.unit = FunctionHelper.exists(data?.unit) ? data.unit : LengthUnit.MILLIMETER;
	}

	public static getFormatDefault(): string {
		return "A4";
	}

	public static getOrientationDefault(): OrientationEnum {
		return OrientationEnum.VERTICAL
	}

	public static getUnitDefault(): LengthUnit {
		return LengthUnit.MILLIMETER;
	}

	public static fromJson(data: any): PortalUrlConverterPage {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalUrlConverterPage(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'format': this.format,
			'orientation': this.orientation,
			'unit': this.unit
		};
	}

	public clone(): PortalUrlConverterPage {
		return PortalUrlConverterPage.fromJson(this.toJson());
	}
}